export default __webpack_public_path__ + "static/media/giphy.94435fb2.webp";